import React from "react";
import LegalLayout from "../components/legal/LegalLayout";

export default function SmsTermsPrivacyPage() {
  return (
    <LegalLayout title="ClearBadge SMS Terms and Privacy" eyebrow="SMS Compliance">
      <article className="legal-card" aria-label="ClearBadge SMS Terms and Privacy">
        <section className="legal-section" id="smstos">
          <h2>SMS Messaging</h2>
          <p>
            ClearBadge may send a one-time transactional SMS containing a secure trust session link when a user
            requests a trust session during a live interaction with a verified professional.
          </p>
          <p>These messages are transactional only and are never used for marketing or promotional purposes.</p>
          <h2>Message Frequency</h2>
          <p>
            Message frequency varies. In most cases, users will receive one SMS message per trust session request. No
            recurring messages are sent.
          </p>
          <h2>Rates</h2>
          <p>Message and data rates may apply depending on your mobile carrier and plan.</p>
          <h2>How to Opt Out</h2>
          <p>
            Reply STOP at any time to opt out of receiving future messages from ClearBadge. You will receive a
            confirmation that you have been unsubscribed.
          </p>
          <h2>Help</h2>
          <p>
            Reply HELP for assistance, or contact us at <a href="mailto:support@clearbadge.org">support@clearbadge.org</a>.
          </p>
          <h2>Privacy &amp; Third-Party Sharing</h2>
          <p>
            Mobile opt-in data and consent information collected for SMS messaging will not be shared with third
            parties or affiliates for marketing or promotional purposes.
          </p>
          <h2>How Consent Is Collected</h2>
          <p>
            Before any SMS is sent, the ClearBadge professional reads a standardized verbal consent script to the
            consumer during a live interaction and receives explicit verbal confirmation. A full explanation of this
            process is available at:{" "}
            <a href="https://clearbadge.org/verbal-consent-sms">clearbadge.org/verbal-consent-sms</a>
          </p>
        </section>
      </article>
    </LegalLayout>
  );
}
